module.exports = __webpack_public_path__ + "static/ancient_kerala-12eb535b9ae0f3ade7cca31be3d84f15.jpg";